import { Card } from "react-bootstrap";
import MarketingBanner from "@/shared/components/MarketingBanner/MarketingBanner";
import InitialsAvatar from "./InitialsAvatar";

interface BannerLivePreviewProps {
    message: string;
    linkText: string;
    linkUrl: string;
}

/** A mock Partner Dashboard around the same MarketingBanner the dashboard renders. */
export default function BannerLivePreview({ message, linkText, linkUrl }: BannerLivePreviewProps) {
    return (
        <Card className="banners-page__card">
            <Card.Body>
                <h2 className="banners-page__card-title">Live Preview</h2>
                <div className="banner-preview" aria-label="Partner Dashboard preview">
                    <div className="banner-preview__header">
                        <span className="banner-preview__title">Partner Dashboard</span>
                        <span className="banner-preview__user">
                            <InitialsAvatar name="Dana Whitfield" size={22} />
                            Dana Whitfield
                        </span>
                    </div>
                    <MarketingBanner
                        message={message}
                        linkText={linkText}
                        linkUrl={linkUrl}
                        placeholder="Your message will appear here."
                    />
                    <div className="banner-preview__body">
                        <div className="banner-preview__welcome">
                            <h3>Welcome to your Partner Dashboard</h3>
                            <p className="mb-0">Johnston Community College</p>
                        </div>
                    </div>
                </div>
            </Card.Body>
        </Card>
    );
}
